import { addDays, startOfDay, isSameDay } from "date-fns";

type Range = {
  startDate: Date;
  endDate: Date;
};

type RangeHandler = {
  label?: string;
  range?: () => Range;
  isSelected?: (range: Range) => boolean;
};

const staticRangeHandler: RangeHandler = {
  isSelected(range: Range) {
    const definedRange = this.range?.();

    if (definedRange?.startDate && definedRange?.endDate)
      return (
        isSameDay(range.startDate, definedRange?.startDate) &&
        isSameDay(range.endDate, definedRange?.endDate)
      );
    return false;
  },
};

export function createStaticRanges(ranges: RangeHandler[]): any[] {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = createStaticRanges([
  {
    label: "Last 7 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -7));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 14 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -14));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 30 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -30));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 60 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -60));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 90 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -90));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 180 days",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -180));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 12 months",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -30 * 12));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Year to date",
    range: () => {
      const startDate = startOfDay(new Date(new Date().getFullYear(), 0, 1));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
  {
    label: "Last 2 years",
    range: () => {
      const startDate = startOfDay(addDays(new Date(), -365 * 2));
      const endDate = startOfDay(new Date());
      return { startDate, endDate };
    },
  },
]);
